import { z } from '../utils/zod.js';
import { adminOrganizationCompactSchema, adminSigningCompactSchema, adminSigningStateSchema, adminUserCompactSchema, } from './compact.js';
import { ADMIN_SORT_DIRECTIONS } from './organization-list.js';
import { adminBooleanQuerySchema, adminPageResponse, adminPaginationQuerySchema } from './pagination.js';
export const ADMIN_SIGNING_SORTS = ['createdAt', 'name', 'state', 'completedAt'];
// A repeated ?state= arrives as an array, a single one as a string; a comma-separated list works too.
const toList = (value) => (typeof value === 'string' ? value.split(',') : value);
export const adminSigningFiltersSchema = z.object({
    q: z
        .string()
        .trim()
        .min(1)
        .max(255)
        .optional()
        .openapi({ description: 'Signing name, signer email or signer name contains' }),
    state: z.preprocess(toList, z.array(adminSigningStateSchema).min(1)).optional(),
    signatureType: z.string().trim().min(1).max(50).optional(),
    organizationId: z.string().uuid().optional(),
    createdById: z.string().uuid().optional(),
    signerEmail: z.string().trim().toLowerCase().email().max(255).optional().openapi({
        description: 'A signer with exactly this email, case-insensitive',
    }),
    from: z.string().datetime({ offset: true }).optional().openapi({ description: 'Created at or after' }),
    to: z.string().datetime({ offset: true }).optional().openapi({ description: 'Created at or before' }),
    includeDeleted: adminBooleanQuerySchema.optional(),
    sort: z.enum(ADMIN_SIGNING_SORTS).default('createdAt'),
    direction: z.enum(ADMIN_SORT_DIRECTIONS).default('desc'),
});
export const adminListSigningsQuerySchema = adminPaginationQuerySchema.merge(adminSigningFiltersSchema);
export const adminSigningListItemSchema = adminSigningCompactSchema.extend({
    organization: adminOrganizationCompactSchema,
    createdBy: adminUserCompactSchema,
    signatureType: z.string().nullable(),
    signersCount: z.number().int(),
    signedCount: z.number().int(),
    documentsCount: z.number().int(),
    completedAt: z.string().datetime().nullable(),
    expirationDate: z.string().datetime().nullable(),
    deletedAt: z.string().datetime().nullable(),
});
export const adminListSigningsResponseSchema = adminPageResponse(adminSigningListItemSchema);
